<template>
  <div class="plugin-box">
    <h2>Vue 3 Component</h2>
    <p>
      This is an example Vue 3 component scaffolded by the script.
    </p>
    <button type="button" @click="increment">
      Clicked {{ counter }} times
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const counter = ref(0);
const increment = () => {
  counter.value++;
};
</script>

<style scoped>
.plugin-box {
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}
</style>
